import { postTimeDisplayFactory } from '@fe-common-utils/libs/time';
import queries from '@fe-news/components/ReactQuery';
import { useQuery } from '@tanstack/react-query';

const CATEGORY_NAME = 'headline';
const LIMIT_NUMBER = 4;

type HotNewType = {
  newsId?: number;
  publishAt?: number;
  categoryName?: string;
  title?: string;
};

const defaultValue = [
  {
    newsId: 0,
    title: '',
    publishAt: Math.floor(Date.now() / 1000)
  }
];

const formateHotNewsData = (data: HotNewType[]) => {
  if (!data?.length) return Array.from({ length: 4 }).fill(defaultValue);

  return data.map(({ publishAt = 0, categoryName, newsId, title }) => {
    const newsTime = postTimeDisplayFactory(publishAt * 1000)?.display ?? '--';

    return { time: newsTime, category: categoryName, newsId, title };
  });
};

const useFetchHotNews = () => {
  const { data } = useQuery({
    ...queries.news.newsCategory({
      category: CATEGORY_NAME,
      limit: LIMIT_NUMBER
    }),
    select: formateHotNewsData,
    initialData: []
  });

  return { data };
};

export default useFetchHotNews;
